import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 12,
    marginBottom: 12,
    overflow: 'hidden'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 0px',
    cursor: 'pointer'
  },
  arrow: {
    marginRight: 8,
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.grey[600]
  },
  title: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.grey[800]
  },
  body: {
    padding: '6px 14px 12px 58px',
    borderTop: `1px solid ${theme.palette.grey[300]}`
  },
  subItem: {
    display: 'flex',
    alignItems: 'center',
    margin: '4px 0',
    fontSize: 13
  }
}))

export default useStyles
